import { render, staticRenderFns } from "./ElectricalDamagesList.vue?vue&type=template&id=021f1e65&scoped=true"
import script from "./ElectricalDamagesList.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamagesList.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamagesList.vue?vue&type=style&index=0&id=021f1e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f1e65",
  null
  
)

export default component.exports